import { style } from 'typestyle';
import { FullscreenIcon } from '../../Icons/MobilePlayerIcons/MediaPlayer/Fullscreen';
import { NoneIcon } from '../../Icons/MobilePlayerIcons/None';

type MobilePlayerDisplay = boolean;

interface Props {
  mobile_player_display: MobilePlayerDisplay;
  onChange: (mobile_player_display: MobilePlayerDisplay) => MobilePlayerDisplay;
}

export function MobilePlayerSelector({ mobile_player_display, ...props }: Props) {
  const onChange = (mobile_player_display: MobilePlayerDisplay) => {
    props.onChange(mobile_player_display);
  };

  return (
    <div className={selectClass}>
      <div className={itemClass}>
        <FullscreenIcon onClick={() => onChange(true)} selected={mobile_player_display === true} />{' '}
        FULLSCREEN{' '}
      </div>
      <div className={itemClass}>
        <NoneIcon
          onClick={() => onChange(false)}
          selected={mobile_player_display === false}
        />{' '}
        NONE{' '}
      </div>
    </div>
  );
}

const selectClass = style({
  marginTop: '10px',
  marginBottom: '10px',
  display: 'flex',
  flexDirection: 'row',
});

const itemClass = style({
  fontSize: '0.7em',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginRight: '10px',
  $nest: {
    '& svg': {
      width: '45px',
      height: '45px',
    }
  }
});
